import { I18nManager, Platform } from "react-native";
import { BRANDING } from "../../assets/consts";
import i18n from "i18n-js";

import en from "./en.json";
import fa from "./fa.json";
import {
  getItemAsync,
  setItemAsync,
} from "../components_v2/DeviceAsyncStorage";

import defConfig from "../config.json"

const getInitialLanguage = async () => {
  const savedLanguage = await getItemAsync("language");
  if (savedLanguage) {
    return savedLanguage;
  }

  const languageTag = defConfig.defaultLanguage;
  return languageTag; // Default to Persian if no language found
};

export const setLanguage = async (languageTag) => {
  await setItemAsync("language", languageTag); // Persist language to AsyncStorage
  i18n.locale = languageTag;
  i18n.isRTL = languageTag === "fa"; // Persian is RTL
};

export const initializeI18n = async (co) => {
  const initialLanguage = await getInitialLanguage();
  setLanguage(initialLanguage); ///Set language based on saved or detected value
  return co
};

// get en fallback as default
i18n.fallbacks = true;

// "guess" mode will use 'space' separated key itself, if key is not provided in translated language.
// example: 'TurnOnLight' will translate to 'Turn On Light'
i18n.missingBehaviour = "guess";

// Define the supported translations
i18n.translations = {
  en,
  fa,
};
const currentLocale = i18n.currentLocale();
// export const IsRTL = false;
export const IsRTL = currentLocale === "fa";

export const IS_WEB = Platform.OS == "web";
export const IS_MOBILE = Platform.OS == "android" || Platform.OS == "ios";
export const RIGHT = Platform.OS === "web" ? "right" : "left";
export const CurrentLocale = currentLocale;
// Allow RTL alignment in RTL languages
I18nManager.forceRTL(IsRTL);
I18nManager.allowRTL(IsRTL);

export function translate(name, params = {}) {
  var result = i18n.t(name, params);
  result = result.replace("TapLife", `${BRANDING.NAME_EN}`);
  result = result.replace("تپ‌لایف", `${BRANDING.NAME_FA}`);
  return result;
}

export const defaultConfig = defConfig;

export default i18n;
